import { IconButton } from '@civilgrid/ui/components';
import { useSnapshot } from 'valtio';
import splitViewStore from '~/components2/Map/Widgets/SplitView/store';
import { useViewMode } from '~/pages/homeViewV2/hooks';
import { homeMapStore as store } from '~/pages/homeViewV2/store';

export function NewProjectButton({ ...rest }: { [key: string]: unknown }) {
  const { inNewProjectMode } = useSnapshot(store) as typeof store;
  const { splitView } = useSnapshot(splitViewStore);
  const { setViewMode } = useViewMode();

  const handleNewProject = () => {
    setViewMode('map');
    store.setNewProjectMode(true);
  };

  if (inNewProjectMode) {
    return null;
  }

  return (
    <IconButton
      onClick={handleNewProject}
      disabled={splitView}
      tooltip="Exit split view to create a project"
      className="h-7"
      icon="plus"
      {...rest}
    >
      New Project
    </IconButton>
  );
}
